import {CachedFile} from "@web-libs/features/chat/api/local-file-cache/cached-file";

export class LocalFileCache {
    _cachedFiles: CachedFile[] = [];

    getCachedFileUrlByIds(internalReferenceId?: string, messageId?: string): string | undefined {
        return this._cachedFiles.find(
            cachedFile => this._isSameInternalReferenceId(cachedFile, internalReferenceId) || this._isSameMessageId(cachedFile, messageId)
        )?.getFileUrl();
    }

    cacheFile(file: File, internalReferenceId?: string, messageId?: string): void {
        this._cachedFiles.push(new CachedFile(file, internalReferenceId, messageId));
    }

    private _isSameInternalReferenceId(cachedFile: CachedFile, internalReferenceId?: string): boolean {
        if(internalReferenceId == undefined) {
            return false
        } else {
            return cachedFile.internalReferenceId === internalReferenceId;
        }
    }

    private _isSameMessageId(cachedFile: CachedFile, messageId?: string): boolean {
        if(messageId == undefined) {
            return false
        } else {
            return cachedFile.messageId === messageId;
        }
    }
}
